import Image from 'next/image';
import Link from 'next/link';
import type { FC } from 'react';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import type { ICourse } from '@/Module/Lesson/Model/DataModel';
import { prepareLinkLesson } from '@/Module/Subscription/Help';
interface IPropsSubscriptionCourseList {
  coursers: Partial<ICourse>[];
}
const SubscriptionCourseList: FC<IPropsSubscriptionCourseList> = ({
  coursers
}) => {
  return <div className="my-6 grid gap-4" data-sentry-component="SubscriptionCourseList" data-sentry-source-file="SubscriptionCourseList.tsx">
      <div className="font-semibold text-blackFive">درس های خریداری شده؛</div>
      {coursers.map(course => <Link key={course.id!} href={prepareLinkLesson({
      seoUrlSlug: course.seoUrlSlug ?? '',
      seoTitle: course.seoTitle ?? ''
    })} className="shadowLight group flex flex-row items-center rounded-xl
                    bg-white px-3 py-2">
          <div>
            <Image alt={course.name || ''} src={`${FILE_BROWSER_URL}/${course.pictureUrl!}`} width={50} height={50} className="relative z-0 ml-2 rounded-xl bg-blueOne p-1" />
          </div>
          <div>{course.seoTitle?.split('|')[0]}</div>
        </Link>)}
    </div>;
};
export default SubscriptionCourseList;